import React from "react";
import css from './ImageButton.module.scss';
import ImagesService from '../../../services/domain/ImagesService';

const ImageButton = (props) => {

  const onChange = (e) => {
    if (!e || !e.target || !e.target.files || !e.target.files.length) {
      return;
    }

    ImagesService.upload(props.imageUploadUrl, e.target.files[0])
        .then(image => {
          props.onChange(props.modifier(props.editorState, image.url));
        })
        .catch((e) => console.log(e));
  };

  return (<React.Fragment>
    <label htmlFor={props.id} className={css.button}>
      <input type="file" accept="image/jpg, image/jpeg, image/gif, image/png" id={props.id}
             onChange={onChange}/>
      <img srcSet={'/static/images/pictos/icon-image.svg'}/>
    </label>
  </React.Fragment>)
};

export default ImageButton;
